export default __webpack_public_path__ + "static/media/cert-student-hkgcsmeaa-sc.6df2d00b.jpg";